var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.isMobile && _vm.websiteInfo.desc)?_c('div',{staticClass:"side-box-section",class:{top:!_vm.websiteInfo.isArea}},[_c('div',{staticClass:"box"},[_c('div',{staticClass:"title"}),_c('div',{staticClass:"content"},[_vm._v(_vm._s(_vm.websiteInfo.desc))])])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }